module.exports = __webpack_public_path__ + "static/media/diamond.e678649d.svg";